<router-outlet />
<syn-splash-screen />
